import initialState from './initialState';
import { reducer as installMultiTenantPluginReducer } from './installMultiTenantPlugin';
import { reducer as getGoogleFontsReducer } from './getGoogleFonts';
import { reducer as addCustomFontsInProjectReducer } from './addCustomFontsInProject';
import { reducer as getCustomFontsReducer } from './getCustomFonts';
import { reducer as deleteCustomFontReducer } from './deleteCustomFont';
import { reducer as addGlobalThemesReducer } from './addGlobalThemes';
import { reducer as getGlobalThemeReducer } from './getGlobalTheme';

const reducers = [installMultiTenantPluginReducer, getGoogleFontsReducer, addCustomFontsInProjectReducer, getCustomFontsReducer, deleteCustomFontReducer, addGlobalThemesReducer, getGlobalThemeReducer];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    // Handle cross-topic actions here
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
